import { AppStartListening } from "@/data/listenerMiddleware";
import { showSentimentCheckModal } from "@/features/sentiment-check";

import { createDateListener } from "../timeline-listeners/create-date-listener";

export function startSentimentCheckListener(startListening: AppStartListening) {
  // notify when the sentiment check date is passed
  createDateListener(
    (state) => state.sentimentCheck,
    (listenerApi) => {
      const assessmentId = listenerApi.getState().authority.assessmentId;
      if (!assessmentId) return;
      listenerApi.dispatch(
        showSentimentCheckModal({
          assessmentId: assessmentId,
        })
      );
    }
  )(startListening);
}
